
function showDontOut() {
    const showDontOutTime1 = 4;
    const showDontOutTime2 = 10;
    const now = new Date().getTime() / 1000;
    const $dontout = $('.dontout');

    if (window.showDontOutStep === 0 && now > window.showDontOuttime + showDontOutTime1) {
        $dontout.show();
        window.showDontOutStep = 1;
    } else if (now > window.showDontOuttime + showDontOutTime2) {
        $dontout.show();
    }
}

export function initDontoutPopup() {
    const $body = $('body');
    const HEADER_HEIGHT = 43;

    window.showDontOutStep = 0;
    window.showDontOuttime = new Date().getTime() / 1000;

    $('.dontout .big_green_button, .dontout_t3')
        .on('click', function onDontOutPopupClick() {
            window.showDontOuttime = new Date().getTime() / 1000;
            $('.dontout').hide();
        });
    $body.on('mouseleave', function onLpDocumentLeave(event) {
        if (event.clientY <= HEADER_HEIGHT) {
            showDontOut();
            window.$errorTooltip.hide();
        }
    });

    $('#js_bottom_but').on('click', function hideRetentionPopup() {
        $('.dontout').hide();
    });
}

